module.exports = __webpack_public_path__ + "static/NanumSquareB-81807f549c75fc3dcde7a54397359a58.eot";